import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import bankAccountBasicInformationPropTypes from '../propTypes/BankAccountPropTypes';
import { CURRENCY_TYPE } from '../../../../../config/constants';
import EnumStatus from '../../../../common/EnumStatus';
import IsActive from '../../../../common/cells/IsActive';

const BankAccountBasicInformationResource = ({
  id,
  bank,
  accountNumber,
  interbankNumber,
  currency,
  receipt,
  business,
  active,
  sunatTableCode,
  sysCode,
  orderNumber,
  externalAccountId,
}) => (
  <>
    <ResourceProperty label="ID:">{id}</ResourceProperty>
    <ResourceProperty label="Banco:">{bank.name}</ResourceProperty>
    <ResourceProperty label="Número de Cuenta:">
      {accountNumber}
    </ResourceProperty>
    <ResourceProperty label="Número de Cuenta Interbancaria:">
      {interbankNumber}
    </ResourceProperty>
    <ResourceProperty label="Tipo de Moneda:">
      <EnumStatus enumObject={CURRENCY_TYPE} enumValue={currency} />
    </ResourceProperty>
    <ResourceProperty label="Convenio/Recaudación:">{receipt}</ResourceProperty>
    <ResourceProperty label="Empresa:">{business.name}</ResourceProperty>
    <ResourceProperty label="Estado:">
      <IsActive value={active} />
    </ResourceProperty>
    <ResourceProperty label="Tabla 3 Sunat:">{sunatTableCode}</ResourceProperty>
    <ResourceProperty label="Código SYS:">{sysCode}</ResourceProperty>
    <ResourceProperty label="Orden:">{orderNumber}</ResourceProperty>
    <ResourceProperty label="ID de Cuenta Externa:">
      {externalAccountId}
    </ResourceProperty>
  </>
);

BankAccountBasicInformationResource.propTypes =
  bankAccountBasicInformationPropTypes;

export default BankAccountBasicInformationResource;
